import MD5 from 'crypto-js/md5';

export const read = (storage, key) => {
	const raw = storage.getItem(key);
	let object;

	try {
		object = raw ? JSON.parse(raw) : null;
	} catch (error) {
		storage.removeItem(key);
		return null;
	}

	if (!object || object == 'undefined' || object == 'null') {
		if (raw) storage.removeItem(key);
		return null;
	}
	if (typeof object !== 'object') {
		storage.removeItem(key);
		return null;
	}
	if (typeof object.expired !== 'number' || !Object.prototype.hasOwnProperty.call(object, 'value')) {
		storage.removeItem(key);
		return null;
	}
	if (object.expired < Date.now()) {
		storage.removeItem(key);
		return null;
	}
	return object.value;
};

const write = (storage, key, value, cache_expired) => {
	const object = {
		expired: Date.now() + cache_expired,
		value: value,
	};
	storage.setItem(key, JSON.stringify(object));
};

export function $getStorage(key) {
	const legacyKey = MD5(key).toString();
	const legacyValue = localStorage.getItem(legacyKey);
	if (legacyValue) {
		if (!localStorage.getItem(key)) {
			try {
				JSON.parse(legacyValue); // Verify it's a valid JSON object, not an old AES string
				localStorage.setItem(key, legacyValue);
			} catch (e) {
				// Legacy value is an AES string, safely ignore
			}
		}
		localStorage.removeItem(legacyKey);
	}

	return read(localStorage, key);
}

export function $setStorage(key, value, cache_expired = 1000 * 60 * 60 * 24 * 356) {
	write(localStorage, key, value, cache_expired);
}

export function $destroyStorage(key) {
	localStorage.removeItem(key);
}

export function $getSession(key) {
	return read(sessionStorage, key);
}

export function $setSession(key, value, cache_expired = 60000) {
	write(sessionStorage, key, value, cache_expired);
}

export function $destroySession(key) {
	sessionStorage.removeItem(key);
}
